module.exports = __webpack_public_path__ + "static/media/help.ea465879.svg";